import React, { useEffect, useState } from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  FormControl,
  FormLabel,
  Input,
  ChakraProvider,
  useToast,
  Select,
  HStack,
  Divider,
  Spacer,
} from '@chakra-ui/react';
import { AppDispatch, Store } from '../Store/StoreInit';
import { useDispatch, useSelector } from 'react-redux';
import axios from 'axios';
import { useMsal } from '@azure/msal-react';
import { fetchPayerMasterList } from '../Store/PayerMasterReducer';
import { IPayerMasterItem } from '../Infrastructure/Interfaces';

interface Props {
  isOpen?: any;
  onOpen?: any;
  onClose?: any;
}

const PayerMasterModalPoupup: React.FC<Props> = (props: Props) => {
  const dispatch = useDispatch<AppDispatch>();
  const [saveButtonLoading, setSaveButtonLoading] = useState(false);
  const toast = useToast();
  const { accounts } = useMsal();
  const userdetails = JSON.parse(localStorage.getItem('userdetails') || '');
  const userid =
    userdetails[0].portal_Id != ''
      ? userdetails[0].portal_Id
      : accounts[0].username;
  const [isPayerNameReq, setIsPayerNameReq] = useState(false);
  const payermasterlist: IPayerMasterItem[] = useSelector((state: any) => {
    return state.payerMasterList.payerMasterList;
  });

  const [data, setdata] = useState({
    payerMasterId: 0,
    payerName: '',
    payerId: '',
    isActive: true,
    createdBy: '',
    createdOn: '0001-01-01T00:00:00',
    modifiedBy: '',
    modifiedOn: '0001-01-01T00:00:00',
  });

  useEffect(() => {
    Store.subscribe(() => {
      setIsPayerNameReq(false);
      setdata({
        ...data,
        payerMasterId: Store.getState().setPayerMasterItem.value.payerMasterId,
        payerName: Store.getState().setPayerMasterItem.value.payerName,
        payerId: Store.getState().setPayerMasterItem.value.payerID,
        isActive: Store.getState().setPayerMasterItem.value.isActive,
        createdBy: Store.getState().setHealthPlanTypeItem.value.createdBy,
        createdOn: Store.getState().setHealthPlanTypeItem.value.createdOn,
        modifiedBy: Store.getState().setHealthPlanTypeItem.value.modifiedBy,
        modifiedOn: Store.getState().setHealthPlanTypeItem.value.modifiedOn,
      });
    });
  }, []);

  const handleChange = (e: any) => {
    e.preventDefault();
    const { id, value } = e.target;
    setdata({
      ...data,
      [id]: value,
    });
  };

  async function handleSubmit(e: { preventDefault: () => void }) {
    e.preventDefault();

    if (data.payerName.trim() === '') {
      setIsPayerNameReq(true);
      return;
    }

    if (data.payerName.trim() !== '') {
      const duplicateItem = payermasterlist.find(
        (x) => x.payerName.trim().toLowerCase() === data.payerName.trim().toLowerCase()
      );
    
      if (duplicateItem && duplicateItem.payerMasterId !== data.payerMasterId) {
        showToast(
          'Error!',
          `${data.payerName} already exists. Please use a different name for a payer.`,
          'error'
        );
        return;
      }
    }
    setSaveButtonLoading(true);

    const payload = {
      payerMasterId: data.payerMasterId,
      payerName: data.payerName.trim(),
      payerId: data.payerId,
      isActive: data.isActive,
      createdBy: userid,
      createdOn: '0001-01-01T00:00:00',
      modifiedBy: userid,
      modifiedOn: '0001-01-01T00:00:00',
    };

    const tokenurl = process.env.REACT_APP_TOKEN_URL_SIS as string;
    const baseurl = process.env.REACT_APP_SERVER_BASE_URL as string;

    try {
      const res = await axios.get(tokenurl);
      if (res.data.success) {
        const url = `${baseurl}/Payer/${
          data.payerMasterId > 0 ? 'update_payername' : 'add_payername'
        }`;

        const axiosMethod = data.payerMasterId > 0 ? axios.put : axios.post;

        const response = await axiosMethod(url, JSON.stringify(payload), {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${res.data.token}`,
          },
        });

        setSaveButtonLoading(false);
        dispatch(fetchPayerMasterList());
        props.onClose();

        if (response.data.success) {
          showToast(
            'Success',
            data.payerName + ' ' + response.data.message,
            'success'
          );
        }
      }
    } catch (error: any) {
      setSaveButtonLoading(false);
      showToast(
        'Error!',
        error.response.data.message || error.message,
        'error'
      );
    }
  }

  function showToast(
    title: string,
    description: string,
    status: 'error' | 'success'
  ) {
    toast({
      title,
      description,
      position: 'top',
      status,
      duration: status === 'error' ? 10000 : 5000,
      isClosable: true,
    });
  }

  return (
    <>
      <ChakraProvider>
        <Modal
          closeOnOverlayClick={false}
          size={'3xl'}
          isOpen={props.isOpen}
          onClose={props.onClose}
        >
          <ModalOverlay />
          <ModalContent>
            <form onSubmit={handleSubmit}>
              <ModalHeader fontWeight="bold">
                <u>Payer Name</u>
              </ModalHeader>
              <ModalCloseButton color="black" />{' '}
              <ModalBody>
                <FormControl mt={2} isRequired isInvalid={isPayerNameReq}>
                  <HStack>
                    <FormLabel width="30%" ml="10px" fontWeight="bold">
                      Payer Name:
                    </FormLabel>
                    <Input
                      size="sm"
                      id="payerName"
                      placeholder="Payer Name"
                      defaultValue={data.payerName}
                      onChange={e => handleChange(e)}
                    />
                  </HStack>
                </FormControl>
                <Divider mt={2} />

                <FormControl mt={2}>
                  <HStack>
                    <FormLabel width="30%" ml="10px" fontWeight="bold">
                      Payer Id:
                    </FormLabel>
                    <Input
                      size="sm"
                      id="payerId"
                      placeholder="Payer ID"
                      defaultValue={data.payerId}
                      onChange={e => handleChange(e)}
                    />
                  </HStack>
                </FormControl>
                <Divider mt={2} />

                <FormControl mt={2} isRequired>
                  <HStack>
                    <FormLabel fontWeight="bold" width="30%" ml="10px">
                      Active:
                    </FormLabel>
                    <Select
                      size="sm"
                      placeholder="--select--"
                      name="isActive"
                      id="isActive"
                      defaultValue={
                        data.isActive == true
                          ? 'true'
                          : data.isActive == false
                          ? 'false'
                          : ''
                      }
                      onChange={e => handleChange(e)}
                    >
                      <option value="true">True</option>
                      <option value="false">False</option>
                    </Select>
                  </HStack>
                </FormControl>
                <Divider mt={2} />
              </ModalBody>
              <ModalFooter>
                <Button bg="#002677" color="white" onClick={props.onClose}>
                  Cancel
                </Button>
                <Spacer />
                <Button
                  isLoading={saveButtonLoading}
                  bg="#002677"
                  color="white"
                  mr={3}
                  type="submit"
                >
                  Save
                </Button>
              </ModalFooter>
            </form>
          </ModalContent>
        </Modal>
      </ChakraProvider>
    </>
  );
};

export default PayerMasterModalPoupup;
